import { render, staticRenderFns } from "./PointBankAnotherlaneConfirm.vue?vue&type=template&id=9550f36c"
import script from "./PointBankAnotherlaneConfirm.vue?vue&type=script&lang=js"
export * from "./PointBankAnotherlaneConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports